<template>
  <div id="TravelDeclarationReport" class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: left; padding: 0px">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 travel-declaration-report">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 travel-declaration-report-header-container" style="padding-top: 20px">
        <h3>Travel Declaration Report</h3>

        <div class="travel-declaration-report-header-action">
          <label>School Name</label>

          <el-select v-model="selectedSch" placeholder="Select School" class="selected-school w-100" @change="ChangeSchool()">
            <el-option v-for="(item, iKey) in schList" :key="item.CONSchool.trim()" :label="item.SCH_Name.trim()" :value="item.CONSchool.trim()"> </el-option>
          </el-select>
        </div>
      </div>

      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 travel-declaration-report-content-container">
        <br />

        <el-button
          size="small"
          type="primary"
          icon="el-icon-download"
          v-on:click="DownloadExcel()"
          v-if="arr_travelDeclarationReport.length > 0 || arr_nonTravelDeclarationReport.length > 0"
          class="pull-right col-lg-3 col-md-3 col-sm-3 col-xs-12"
          >Download
        </el-button>

        <div class="all-travel-declaration-report">
          <h4>Travel Submission</h4>

          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="padding: 0px">
            <label style="display: inline-block !important">Filter by:</label>

            <el-select v-model="ddlFilterType" style="margin-left: 10px" @change="changeFilterType()">
              <el-option v-for="(item, iKey) in ddlFilterTypeList" :key="iKey" :label="item.label" :value="item.prop" placeholder="Select Reason"></el-option>
            </el-select>

            <div style="margin-top: 10px">
              <div class="date" v-if="ddlFilterType === 'DateRange'">
                <el-date-picker
                  @change="changeFilterDate()"
                  v-model="filterDate"
                  type="daterange"
                  range-separator="TO"
                  start-placeholder="From Date"
                  end-placeholder="To Date"
                  format="dd/MM/yyyy"
                  value-format="dd/MM/yyyy"
                  style="max-width: 100%"
                  ref="elDataPicker"
                >
                </el-date-picker>
                OR
                <el-select v-model="filterAcademicYear" style="margin-left: 10px" @change="changeFilterAcademicYear()">
                  <el-option
                    v-for="(item, iKey) in academicYearList"
                    :key="iKey"
                    :label="item.SMT_Code"
                    :value="item.PK_Semester_ID"
                    placeholder="Select Academic Year"
                  ></el-option>
                </el-select>
              </div>

              <div
                class="filter-text-container"
                @keyup="filterTextWithType"
                v-if="ddlFilterType !== 'DateRange' && ddlFilterType !== 'CreatedDate' && ddlFilterType !== '' && ddlFilterType !== 'SCRS_From_Date'"
              >
                <input type="text" class="form-control form-control-primary" v-model="filterText" />
              </div>

              <div class="filter-created-date" v-if="ddlFilterType === 'CreatedDate'" style="width: 50%">
                <el-date-picker
                  @change="changeFilterCreatedDate()"
                  v-model="filterCreatedDate"
                  type="date"
                  placeholder="Pick a Date"
                  format="dd/MM/yyyy"
                  value-format="dd/MM/yyyy"
                  style="max-width: 100%"
                >
                </el-date-picker>
              </div>
              <div class="filter-commecement-date" v-if="ddlFilterType === 'SCRS_From_Date'" style="width: 50%">
                <el-date-picker
                  @change="changeFilterSCRSFromDate()"
                  v-model="filterSCRSFromDate"
                  type="date"
                  placeholder="Pick a Date"
                  format="dd/MM/yyyy"
                  value-format="dd/MM/yyyy"
                  style="max-width: 100%"
                >
                </el-date-picker>
              </div>
            </div>

            <div class="reset-button" v-if="ddlFilterType !== ''" style="margin: 10px 0px">
              <el-button size="small" type="primary" v-on:click="clearFilter()" class="col-lg-3 col-md-3 col-sm-3 col-xs-12">Reset Filter </el-button>
            </div>
          </div>

          <data-tables :data="arr_travelDeclarationReport">
            <el-table-column v-for="info in travelDeclarationReportTable" :prop="info.prop" :label="info.label" :key="info.prop" sortable="custom">
              <!--                            width="150"-->
            </el-table-column>
          </data-tables>
        </div>

        <div class="all-non-travel-declaration-report" style="margin-top: 20px">
          <h4>Not Travelling Submission</h4>

          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="padding: 0px">
            <label style="display: inline-block !important">Filter by:</label>

            <el-select v-model="ddlNotTravelFilterType" style="margin-left: 10px" @change="changeNotTravelFilterType()">
              <el-option
                v-for="(item, iKey) in ddlNotTravelFilterTypeList"
                :key="iKey"
                :label="item.label"
                :value="item.prop"
                placeholder="Select Reason"
              ></el-option>
            </el-select>

            <div style="margin-top: 10px">
              <div class="date" v-if="ddlNotTravelFilterType === 'DateRange'">
                <el-date-picker
                  @change="changeNotTravelFilterDate()"
                  v-model="filterNotTravelDate"
                  type="daterange"
                  range-separator="TO"
                  start-placeholder="From Date"
                  end-placeholder="To Date"
                  format="dd/MM/yyyy"
                  value-format="dd/MM/yyyy"
                  style="max-width: 100%"
                >
                </el-date-picker>
              </div>
            </div>

            <div class="reset-button" v-if="ddlNotTravelFilterType !== ''" style="margin: 10px 0px">
              <el-button size="small" type="primary" v-on:click="clearNotTravelFilter()" class="col-lg-3 col-md-3 col-sm-3 col-xs-12">Reset Filter </el-button>
            </div>
          </div>

          <data-tables :data="arr_nonTravelDeclarationReport">
            <el-table-column v-for="info in nonTravelDeclarationReportTable" :prop="info.prop" :label="info.label" :key="info.prop" sortable="custom">
            </el-table-column>
          </data-tables>
        </div>

        <div class="all-non-travel-declaration-report" style="margin-top: 20px">
          <h4>Pending Travel Submission</h4>
          <data-tables :data="arr_noTravelDeclarationReport">
            <el-table-column v-for="info in noTravelDeclarationReportTable" :prop="info.prop" :label="info.label" :key="info.prop" sortable="custom">
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import Cookies from 'js-cookie'
import moment from 'moment'
import XLSX from 'xlsx'

export default {
  name: 'TravelDeclarationReport',
  data() {
    return {
      selectedSch: '',
      isChanged: false,
      arr_oriTravelDeclarationReport: [],
      arr_travelDeclarationReport: [],
      travelDeclarationReportTable: [
        {
          prop: 'index_no',
          label: 'Student No',
        },
        {
          prop: 'student_name',
          label: 'Name of Student',
        },
        {
          prop: 'SCRS_From_Date',
          label: 'Commencement Date',
        },
        {
          prop: 'SCRS_Status',
          label: 'Status',
        },
        {
          prop: 'Nationality',
          label: 'Nationality Country of Origin',
        },
        {
          prop: 'IdentityNo',
          label: 'FIN/NRIC/Passport',
        },
        {
          prop: 'FullAddress',
          label: 'Full Address in Singapore',
        },
        {
          prop: 'PAR_Mother_Phone',
          label: 'Mother Contact',
        },
        {
          prop: 'PAR_Mother_Email',
          label: 'Mother Email',
        },
        {
          prop: 'PAR_Father_Phone',
          label: 'Father Contact',
        },
        {
          prop: 'PAR_Father_Email',
          label: 'Father Email',
        },
        {
          prop: 'ParTrvDclFromDate',
          label: 'Date of Travel (DD/MM/YY)',
        },
        {
          prop: 'ParTrvDclToDate',
          label: 'End of Travel (DD/MM/YY)',
        },
        {
          prop: 'ParTrvDclCountry',
          label: 'Travel to Country',
        },
        {
          prop: 'ParTrvDclCity',
          label: 'Travel to City',
        },
        {
          prop: 'ParTrvDclTransDate',
          label: 'Date of Transit (DD/MM/YY)',
        },
        {
          prop: 'ParTrvDclTransCountry',
          label: 'Transit Country',
        },
        {
          prop: 'ParTrvDclTransCity',
          label: 'Transit City',
        },
        {
          prop: 'ParTrvDclRelLeave',
          label: 'Close contact to LOA/SHN/HQO',
        },
        {
          prop: 'ParTrvDclRelLeaveEndDate',
          label: 'Last date of close contact to LOA/SHN/HQO',
        },
        {
          prop: 'ParTrvDclRemark',
          label: 'Remarks',
        },
        {
          prop: 'ParTrvDclStatus',
          label: 'Trip Status',
        },

        {
          prop: 'ParTrvDclCancelRemark',
          label: 'Reason of cancel trip',
        },
        {
          prop: 'ParTrvDclCreatedOn',
          label: 'Submission Date',
        },
        {
          prop: 'CONname',
          label: 'Declared By',
        },
      ],

      arr_oriNonTravelDeclarationReport: [],
      arr_nonTravelDeclarationReport: [],
      nonTravelDeclarationReportTable: [
        {
          prop: 'index_no',
          label: 'Student No',
        },
        {
          prop: 'student_name',
          label: 'Name of Student',
        },
        {
          prop: 'SCRS_From_Date',
          label: 'Commencement Date',
        },
        {
          prop: 'SCRS_Status',
          label: 'Status',
        },
        {
          prop: 'Nationality',
          label: 'Nationality Country of Origin',
        },
        {
          prop: 'IdentityNo',
          label: 'FIN/NRIC/Passport',
        },
        {
          prop: 'FullAddress',
          label: 'Full Address in Singapore',
        },
        {
          prop: 'PAR_Mother_Phone',
          label: 'Mother Contact',
        },
        {
          prop: 'PAR_Mother_Email',
          label: 'Mother Email',
        },
        {
          prop: 'PAR_Father_Phone',
          label: 'Father Contact',
        },
        {
          prop: 'PAR_Father_Email',
          label: 'Father Email',
        },
        {
          prop: 'ParTrvDclFromDate',
          label: 'Date of Travel (DD/MM/YY)',
        },
        {
          prop: 'ParTrvDclToDate',
          label: 'End of Travel (DD/MM/YY)',
        },
        {
          prop: 'ParTrvDclRelLeave',
          label: 'Close contact to LOA/SHN/HQO',
        },
        {
          prop: 'ParTrvDclRelLeaveEndDate',
          label: 'Last date of close contact to LOA/SHN/HQO',
        },
        {
          prop: 'ParTrvDclRemark',
          label: 'Remarks',
        },
        {
          prop: 'ParTrvDclCreatedOn',
          label: 'Submission Date',
        },
        {
          prop: 'CONname',
          label: 'Declared By',
        },
      ],

      arr_noTravelDeclarationReport: [],
      noTravelDeclarationReportTable: [
        {
          prop: 'Index_No',
          label: 'Student No',
        },
        {
          prop: 'student_name',
          label: 'Name of Student',
        },
        {
          prop: 'SCRS_From_Date',
          label: 'Commencement Date',
        },
        {
          prop: 'SCRS_Status',
          label: 'Status',
        },
        {
          prop: 'Nationality',
          label: 'Nationality Country of Origin',
        },
        {
          prop: 'IdentityNo',
          label: 'FIN/NRIC/Passport',
        },
        {
          prop: 'FullAddress',
          label: 'Full Address in Singapore',
        },
        {
          prop: 'PAR_Mother_Phone',
          label: 'Mother Contact',
        },
        {
          prop: 'PAR_Mother_Email',
          label: 'Mother Email',
        },
        {
          prop: 'PAR_Father_Phone',
          label: 'Father Contact',
        },
        {
          prop: 'PAR_Father_Email',
          label: 'Father Email',
        },
      ],

      schList: [],
      schListCurrent: '',
      academicYearList: [],
      ddlFilterType: '',
      ddlFilterTypeList: [
        {
          prop: 'DateRange',
          label: 'Traveling Date',
        },
        {
          prop: 'TravelCountry',
          label: 'Travel Country',
        },
        {
          prop: 'TravelCity',
          label: 'Travel City',
        },
        {
          prop: 'TransitCountry',
          label: 'Transit Country',
        },
        {
          prop: 'TransitCity',
          label: 'Transit City',
        },
        {
          prop: 'StudentName',
          label: 'Student Name',
        },
        {
          prop: 'SCRS_From_Date',
          label: 'Commencement Date',
        },
        {
          prop: 'CreatedDate',
          label: 'Created Date',
        },
      ],
      filterDate: '',
      filterText: '',
      filterCreatedDate: '',
      filterSCRSFromDate: '',
      filterAcademicYear: '',
      ddlNotTravelFilterType: '',
      ddlNotTravelFilterTypeList: [
        {
          prop: 'DateRange',
          label: 'Not Traveling Period',
        },
      ],
      filterNotTravelDate: '',

      checkMobileStatus: false,
    }
  },
  async created() {
    this.filterDate = ''
    await this.BindSchoolList()
    window.addEventListener('resize', this.isMobile)
  },
  destroy() {
    window.removeEventListener('resize', this.isMobile)
  },
  methods: {
    isMobile() {
      let screenWidth = window.innerWidth
      if (screenWidth <= 770) {
        this.checkMobileStatus = true
        return true
      } else {
        this.checkMobileStatus = false
        return false
      }
    },
    async BindAcademicYearList() {
      //
      try {
        const response = await DataSource.shared.getAcademicYearBySchoolID(this.selectedSch)
        if (response) {
          this.academicYearList = response.Table
        }
      } catch (e) {
        this.results = e
      }
    },
    async BindSchoolList() {
      try {
        const response = await DataSource.shared.getUserSch()
        if (response) {
          this.schListResponse = response.Table.filter(sch => {
            return sch.CONid !== '11467'
          })
          this.schListResponse.forEach(m => {
            this.schList.push(m)
            if (Cookies.get('schoolSession') === m.CONSchool) {
              this.selectedSch = m.CONSchool.trim()
              this.getTravelDeclarationReport()
              this.getNonTravelDeclarationReport()
              this.getUnTravelDeclarationReport()
              this.BindAcademicYearList()
            }
          })
        }
      } catch (e) {
        this.results = e
      }
    },

    async ChangeSchool() {
      try {
        this.getTravelDeclarationReport()
        this.getNonTravelDeclarationReport()
        this.getUnTravelDeclarationReport()
        this.BindAcademicYearList()
      } catch (e) {
        this.results = e
      }
    },

    async getTravelDeclarationReport() {
      try {
        this.$vs.loading()
        this.arr_travelDeclarationReport = []

        const response = await DataSource.shared.getTravelDeclarationReport(this.selectedSch)

        // console.log(response, "resp");
        if (response) {
          this.$vs.loading.close()

          if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Please try again later',
            })

            return
          }

          if (response.code === '2') {
            this.arr_travelDeclarationReport = []
            // this.$notify.error({
            //     title: 'Error',
            //     message: 'No record found'
            // });

            return
          }

          response.Table.forEach(item => {
            item.SCRS_From_Date = moment(item.SCRS_From_Date).format('DD/MM/YYYY')
            item.ParTrvDclCreatedOn = moment(item.ParTrvDclCreatedOn).format('DD/MM/YYYY')
            item.ParTrvDclFromDate = moment(item.ParTrvDclFromDate).format('DD/MM/YYYY')
            item.ParTrvDclToDate = moment(item.ParTrvDclToDate).format('DD/MM/YYYY')
            if (item.ParTrvDclTransDate === null || item.ParTrvDclTransDate === '' || item.ParTrvDclTransDate === undefined) {
              item.ParTrvDclTransDate = ''
            } else {
              item.ParTrvDclTransDate = moment(item.ParTrvDclTransDate).format('DD/MM/YYYY')
            }
            if (item.ParTrvDclRelLeaveEndDate === null || item.ParTrvDclRelLeaveEndDate === '' || item.ParTrvDclRelLeaveEndDate === undefined) {
              item.ParTrvDclRelLeaveEndDate = ''
            } else {
              item.ParTrvDclRelLeaveEndDate = moment(item.ParTrvDclRelLeaveEndDate).format('DD/MM/YYYY')
            }

            if (item.ParTrvDclStatus == 'Active') {
              item.ParTrvDclStatus = 'Yes'
            }

            if (item.Nationality === 'Singaporean') {
              item.IdentityNo = item.Birth_Cert
            } else {
              if (item.FIN !== '') {
                item.IdentityNo = item.FIN
              } else {
                item.IdentityNo = item.St_Passport_Number
              }
            }
          })

          let objDuplicate = {
            arrIndexNo: [],
            arrFromDate: [],
            arrToDate: [],
            arrTravelCountry: [],
          }
          response.Table = response.Table.filter(d => {
            let isValid = true

            if (d.ParTrvDclStatus === 'Cancel') {
              d.ParTrvDclCancelRemark = 'wrong input'
              if (d.ParTrvDclCancelRemark !== undefined && d.ParTrvDclCancelRemark.toLowerCase() === 'wrong input') {
                isValid = false
              }
            } else {
              let indexNoDuplicate = false,
                fromDateDuplicate = false,
                toDateDuplicate = false,
                trvCountryDuplicate = false

              if (!objDuplicate.arrIndexNo.includes(d.index_no)) {
                objDuplicate.arrIndexNo.push(d.index_no)
              } else {
                indexNoDuplicate = true
              }

              if (!objDuplicate.arrFromDate.includes(d.ParTrvDclFromDate)) {
                objDuplicate.arrFromDate.push(d.ParTrvDclFromDate)
              } else {
                fromDateDuplicate = true
              }

              if (!objDuplicate.arrToDate.includes(d.ParTrvDclToDate)) {
                objDuplicate.arrToDate.push(d.ParTrvDclToDate)
              } else {
                toDateDuplicate = true
              }

              if (!objDuplicate.arrTravelCountry.includes(d.ParTrvDclCountry)) {
                objDuplicate.arrTravelCountry.push(d.ParTrvDclCountry)
              } else {
                trvCountryDuplicate = true
              }

              if (indexNoDuplicate && fromDateDuplicate && toDateDuplicate && trvCountryDuplicate) {
                isValid = false
              }
            }

            return isValid
          })

          this.arr_oriTravelDeclarationReport = response.Table
          this.arr_travelDeclarationReport = response.Table
        }
      } catch (e) {
        console.log(e)
      }
    },

    async getNonTravelDeclarationReport() {
      try {
        this.$vs.loading()
        this.arr_nonTravelDeclarationReport = []

        const response = await DataSource.shared.getNonTravelDeclarationReport(this.selectedSch)

        // console.log(response, "non resp");
        if (response) {
          this.$vs.loading.close()

          if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Please try again later',
            })

            return
          }

          if (response.code === '2') {
            this.arr_nonTravelDeclarationReport = []
            // this.$notify.error({
            //     title: 'Error',
            //     message: 'No record found'
            // });
            //
            return
          }

          response.Table.forEach(item => {
            item.SCRS_From_Date = moment(item.SCRS_From_Date).format('DD/MM/YYYY')
            item.ParTrvDclCreatedOn = moment(item.ParTrvDclCreatedOn).format('DD/MM/YYYY')
            item.ParTrvDclFromDate = moment(item.ParTrvDclFromDate).format('DD/MM/YYYY')
            item.ParTrvDclToDate = moment(item.ParTrvDclToDate).format('DD/MM/YYYY')
            if (item.ParTrvDclRelLeaveEndDate === null || item.ParTrvDclRelLeaveEndDate === '' || item.ParTrvDclRelLeaveEndDate === undefined) {
              item.ParTrvDclRelLeaveEndDate = ''
            } else {
              item.ParTrvDclRelLeaveEndDate = moment(item.ParTrvDclRelLeaveEndDate).format('DD/MM/YYYY')
            }

            if (item.ParTrvDclStatus == 'Active') {
              item.ParTrvDclStatus = 'Yes'
            }

            if (item.Nationality === 'Singaporean') {
              item.IdentityNo = item.Birth_Cert
            } else {
              if (item.FIN !== '') {
                item.IdentityNo = item.FIN
              } else {
                item.IdentityNo = item.St_Passport_Number
              }
            }
          })

          let arrStudentNo = []
          response.Table = response.Table.filter(d => {
            let isValid = true
            if (d.ParTrvDclStatus === 'Cancel') {
              // if (d.ParTrvDclCancelRemark !== undefined && d.ParTrvDclCancelRemark.toLowerCase() === "wrong input") {
              //     isValid = false;
              // }
              isValid = false
            } else {
              if (!arrStudentNo.includes(d.index_no)) {
                arrStudentNo.push(d.index_no)
              } else {
                isValid = false
              }
            }

            return isValid
          })

          this.arr_oriNonTravelDeclarationReport = response.Table
          this.arr_nonTravelDeclarationReport = response.Table
        }
      } catch (e) {
        console.log(e)
      }
    },

    async getUnTravelDeclarationReport() {
      try {
        this.$vs.loading()
        this.arr_noTravelDeclarationReport = []

        const response = await DataSource.shared.getParentTravelUnDeclaration(this.selectedSch)

        if (response) {
          this.$vs.loading.close()

          if (response) {
            if (response.code === '2') {
              console.log('Get Paren tTravel Un Declaration: No Record')
            } else if (response.code === '99') {
              console.log('Get Paren tTravel Un Declaration: Error')
            } else if (response.code === '88') {
              window.location.replace('/')
            } else {
              response.Table.forEach(item => {
                item.SCRS_From_Date = moment(item.SCRS_From_Date).format('DD/MM/YYYY')
                if (item.Nationality === 'Singaporean') {
                  item.IdentityNo = item.Birth_Cert
                } else {
                  if (item.FIN !== '') {
                    item.IdentityNo = item.FIN
                  } else {
                    item.IdentityNo = item.St_Passport_Number
                  }
                }
              })

              let arrStudentNo = []
              response.Table = response.Table.filter(d => {
                let isValid = false

                if (!arrStudentNo.includes(d.Index_No)) {
                  arrStudentNo.push(d.Index_No)
                  isValid = true
                }

                return isValid
              })

              this.arr_noTravelDeclarationReport = response.Table
            }
          }
        }
      } catch (e) {
        console.log(e)
      }
    },

    changeFilterType() {
      this.filterDate = ''
      this.filterText = ''
      this.filterCreatedDate = ''
      this.filterSCRSFromDate = ''
      this.filterAcademicYear = ''
    },
    changeFilterAcademicYear() {
      let selectedAcademic = this.academicYearList.filter(fItem => {
        return fItem.PK_Semester_ID == this.filterAcademicYear
      })
      this.filterDate = []
      this.$set(this.filterDate, 0, new Date(selectedAcademic[0].SMT_From))
      this.$set(this.filterDate, 1, new Date(selectedAcademic[0].SMT_To))
      this.changeFilterDate()
    },
    changeFilterDate() {
      console.log(this.filterDate)
      if (this.filterDate !== null || this.filterDate !== '') {
        let selectedAcademic = this.academicYearList.filter(fItem => {
          return moment(fItem.SMT_From).isSame(moment(this.filterDate[0])) && moment(fItem.SMT_To).isSame(moment(this.filterDate[1]))
        })
        if (selectedAcademic.length == 0) {
          this.filterAcademicYear = ''
        }

        this.arr_oriTravelDeclarationReport.forEach(item => {
          item.IsFilter = false

          let fromDate = moment(item.ParTrvDclFromDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
          let toDate = moment(item.ParTrvDclToDate, 'DD/MM/YYYY').format('YYYY-MM-DD')

          let selectedFromDate = moment(this.filterDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
          let selectedToDate = moment(this.filterDate[1], 'DD/MM/YYYY').format('YYYY-MM-DD')

          if (moment(fromDate).isBetween(selectedFromDate, selectedToDate) && moment(toDate).isBetween(selectedFromDate, selectedToDate)) {
            item.IsFilter = true
          }
        })

        this.arr_travelDeclarationReport = this.arr_oriTravelDeclarationReport.filter(fItem => {
          return fItem.IsFilter
        })
      }
    },
    filterTextWithType(val) {
      if (this.ddlFilterType === 'TravelCountry') {
        this.arr_travelDeclarationReport = this.arr_oriTravelDeclarationReport.filter(fItem => {
          if (fItem.ParTrvDclCountry) {
            return fItem.ParTrvDclCountry.toLowerCase().trim().includes(val.target.value.toLowerCase().trim())
          }
        })
      }

      if (this.ddlFilterType === 'TravelCity') {
        this.arr_travelDeclarationReport = this.arr_oriTravelDeclarationReport.filter(fItem => {
          if (fItem.ParTrvDclCity) {
            return fItem.ParTrvDclCity.toLowerCase().trim().includes(val.target.value.toLowerCase().trim())
          }
        })
      }

      if (this.ddlFilterType === 'TransitCountry') {
        this.arr_travelDeclarationReport = this.arr_oriTravelDeclarationReport.filter(fItem => {
          if (fItem.ParTrvDclTransCountry) {
            return fItem.ParTrvDclTransCountry.toLowerCase().trim().includes(val.target.value.toLowerCase().trim())
          }
        })
      }

      if (this.ddlFilterType === 'TransitCity') {
        this.arr_travelDeclarationReport = this.arr_oriTravelDeclarationReport.filter(fItem => {
          if (fItem.ParTrvDclTransCity) {
            return fItem.ParTrvDclTransCity.toLowerCase().trim().includes(val.target.value.toLowerCase().trim())
          }
        })
      }

      if (this.ddlFilterType === 'StudentName') {
        this.arr_travelDeclarationReport = this.arr_oriTravelDeclarationReport.filter(fItem => {
          if (fItem.student_name) {
            return fItem.student_name.toLowerCase().trim().includes(val.target.value.toLowerCase().trim())
          }
        })
      }

      if (val.target.value === '') {
        this.arr_travelDeclarationReport = this.arr_oriTravelDeclarationReport
      }
    },

    changeFilterCreatedDate() {
      if (this.filterCreatedDate !== null || this.filterCreatedDate !== '') {
        this.arr_travelDeclarationReport = this.arr_oriTravelDeclarationReport.filter(fItem => {
          let fromDate = moment(fItem.ParTrvDclCreatedOn, 'DD/MM/YYYY').format('YYYY-MM-DD')
          let selectedFromDate = moment(this.filterCreatedDate, 'DD/MM/YYYY').format('YYYY-MM-DD')

          if (fItem.ParTrvDclCreatedOn) {
            return fromDate === selectedFromDate
          }
        })
      }
    },
    changeFilterSCRSFromDate() {
      if (this.filterSCRSFromDate !== null || this.filterSCRSFromDate !== '') {
        this.arr_travelDeclarationReport = this.arr_oriTravelDeclarationReport.filter(fItem => {
          let fromDate = moment(fItem.SCRS_From_Date, 'DD/MM/YYYY').format('YYYY-MM-DD')
          let selectedFromDate = moment(this.filterSCRSFromDate, 'DD/MM/YYYY').format('YYYY-MM-DD')

          if (fItem.SCRS_From_Date) {
            return fromDate === selectedFromDate
          }
        })
      }
    },
    clearFilter() {
      this.ddlFilterType = ''
      this.filterDate = ''
      this.filterText = ''
      this.filterCreatedDate = ''
      this.arr_travelDeclarationReport = this.arr_oriTravelDeclarationReport
    },

    changeNotTravelFilterType() {
      this.filterNotTravelDate = ''
    },

    changeNotTravelFilterDate() {
      if (this.filterNotTravelDate !== null || this.filterNotTravelDate !== '') {
        this.arr_oriNonTravelDeclarationReport.forEach(item => {
          item.IsFilter = false

          let fromDate = moment(item.ParTrvDclFromDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
          let toDate = moment(item.ParTrvDclToDate, 'DD/MM/YYYY').format('YYYY-MM-DD')

          let selectedFromDate = moment(this.filterNotTravelDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
          let selectedToDate = moment(this.filterNotTravelDate[1], 'DD/MM/YYYY').format('YYYY-MM-DD')

          // moment(fromDate) >= moment(selectedFromDate) && moment(toDate) <= moment(selectedToDate)
          if (moment(fromDate).isBetween(selectedFromDate, selectedToDate) && moment(toDate).isBetween(selectedFromDate, selectedToDate)) {
            item.IsFilter = true
          }
        })

        this.arr_nonTravelDeclarationReport = this.arr_oriNonTravelDeclarationReport.filter(fItem => {
          return fItem.IsFilter
        })
      }
    },

    clearNotTravelFilter() {
      this.ddlNotTravelFilterType = ''
      this.filterNotTravelDate = ''
      this.arr_nonTravelDeclarationReport = this.arr_oriNonTravelDeclarationReport
    },

    DownloadExcel() {
      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, '/')

      let exportTravelExcelObject = []
      this.arr_travelDeclarationReport.forEach(m => {
        let tempList = {
          'Student No': m.index_no,
          'Full Name': m.student_name,
          'Commencement Date': m.SCRS_From_Date,
          Status: m.SCRS_Status,
          'Nationality Country of Origin': m.Nationality,
          'FIN/NRIC/Passport': m.IdentityNo,
          'Date of Travel (DD/MM/YY)': m.ParTrvDclFromDate,
          'End of Travel (DD/MM/YY)': m.ParTrvDclToDate,
          'Travel to Country': m.ParTrvDclCountry,
          'Travel to City': m.ParTrvDclCity,
          'Date of Transit (DD/MM/YY)': m.ParTrvDclTransDate,
          'Transit Country': m.ParTrvDclTransCountry,
          'Transit City': m.ParTrvDclTransCity,
          'Full Address in Singapore': m.FullAddress,
          'Mother Contact': m.PAR_Mother_Phone,
          'Mother Email': m.PAR_Mother_Email,
          'Father Contact': m.PAR_Father_Phone,
          'Father Email': m.PAR_Father_Email,
          'Trip Status': m.ParTrvDclStatus,
          'Submission Date': m.ParTrvDclCreatedOn,
          Remarks: m.ParTrvDclRemark,
          'Declared By': m.CONname,
        }
        exportTravelExcelObject.push(tempList)
      })

      let exportNonTravelExcelObject = []
      this.arr_nonTravelDeclarationReport.forEach(m => {
        let tempList = {
          'Student No': m.index_no,
          'Full Name': m.student_name,
          'Commencement Date': m.SCRS_From_Date,
          Status: m.SCRS_Status,
          'Nationality Country of Origin': m.Nationality,
          'FIN/NRIC/Passport': m.IdentityNo,
          'Date of Travel (DD/MM/YY)': m.ParTrvDclFromDate,
          'End of Travel (DD/MM/YY)': m.ParTrvDclToDate,
          'Full Address in Singapore': m.FullAddress,
          'Mother Contact': m.PAR_Mother_Phone,
          'Mother Email': m.PAR_Mother_Email,
          'Father Contact': m.PAR_Father_Phone,
          'Father Email': m.PAR_Father_Email,
          'Trip Status': m.ParTrvDclStatus,
          'Submission Date': m.ParTrvDclCreatedOn,
          'Declared By': m.CONname,
        }
        exportNonTravelExcelObject.push(tempList)
      })

      let exportNoTravelExcelObject = []
      this.arr_noTravelDeclarationReport.forEach(m => {
        let tempList = {
          'Student No': m.Index_No,
          'Full Name': m.student_name,
          'Commencement Date': m.SCRS_From_Date,
          Status: m.SCRS_Status,
          'Nationality Country of Origin': m.Nationality,
          'FIN/NRIC/Passport': m.IdentityNo,
          'Full Address in Singapore': m.FullAddress,
          'Mother Contact': m.PAR_Mother_Phone,
          'Mother Email': m.PAR_Mother_Email,
          'Father Contact': m.PAR_Father_Phone,
          'Father Email': m.PAR_Father_Email,
        }
        exportNoTravelExcelObject.push(tempList)
      })

      var wb2 = XLSX.utils.book_new() // make Workbook of Excel

      var sheetTravel = XLSX.utils.json_to_sheet(exportTravelExcelObject)
      var sheetNonTravel = XLSX.utils.json_to_sheet(exportNonTravelExcelObject)
      var sheetNoTravel = XLSX.utils.json_to_sheet(exportNoTravelExcelObject)

      XLSX.utils.book_append_sheet(wb2, sheetTravel, 'TravelSubmission') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb2, sheetNonTravel, 'NotTravellingSubmission') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb2, sheetNoTravel, 'PendingTravelSubmission') // sheetAName is name of Worksheet

      XLSX.writeFile(wb2, 'Travel Declaration Report - ' + currentDateWithFormat + '.xlsx') // name of the file is 'book.xlsx'
    },
  },
  mounted() {},
}
</script>

<style scoped></style>

<style>
#TravelDeclarationReport .el-select input {
  background: white;
}

#TravelDeclarationReport .el-date-editor .el-range-separator {
  width: auto;
}

#TravelDeclarationReport .filter-created-date .el-date-editor.el-input input {
  background: white;
}
</style>
